import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { CurrentUserStateService } from '../../services/current-user-state.service';

@Component({
    selector: 'lg-footer',
    templateUrl: './lg-footer.component.html',
    styleUrls: ['./lg-footer.component.scss'],
})
export class LGFooterComponent implements OnInit {
    today: number = Date.now();
    currentYear: number = new Date().getFullYear();

    constructor(public currentUserStateService: CurrentUserStateService) {}

    ngOnInit() {}
}
